/**
 * обновление контента шапки и подвала из pjax ответа
 */
import {Widget} from "base/assets/js/widget/Widget.js";
import {Layout} from "./Layout.js";

export class LayoutUpdate extends Widget {

	run() {
		const oLayout = this._rel().typeOf( Layout ).find();
		const oOpts = this._attr( '', 'js:json' );
		oLayout.update( oOpts );
	}
}